// Mapbox configuration
export const mapboxConfig = {
  // Replace with your actual Mapbox access token
  accessToken: "pk.eyJ1IjoicG1pZGRlbGRvcnAiLCJhIjoiY21hZ21ka3J2MDJpdTJrcXN3NThmY3JjeSJ9.QFFeiY2Bfqrk6XxATrYxcQ",

  // Map style - you can change this to other Mapbox styles
  // Available styles: mapbox://styles/mapbox/streets-v12, mapbox://styles/mapbox/outdoors-v12,
  // mapbox://styles/mapbox/light-v11, mapbox://styles/mapbox/dark-v11, mapbox://styles/mapbox/satellite-v9
  style: "mapbox://styles/mapbox/streets-v12",

  // Default map center and zoom
  center: [5.8917905224909415, 51.98593576093725], // [lng, lat]
  zoom: 12,

  // Map options
  scrollZoom: false,
  dragPan: true,
  dragRotate: true,
  keyboard: true,
  doubleClickZoom: true,
  touchZoomRotate: true,
};
